<template>
    <div id="app-drawer">
        <v-sheet color="grey lighten-4" class="pa-4">
            <router-link :to="'/'">
                <v-img :src="logo" height="100" contain :to="'/'" />
            </router-link>
        </v-sheet>
        <v-divider></v-divider>
        <v-list-item v-if="$auth.isAuthenticated && !$auth.loading && !!userName" :to="'/user-profile'" class="py-1">
            <v-list-item-avatar>
                <img :src="$auth.user.picture">
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title id="profile_username"><span>{{userName}}</span></v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list v-if="$auth.isAuthenticated && !$auth.loading">
            <template v-for="(link) in links">
                <template v-if="checkAccess(link.title)">
                    <v-list-item v-if="!link.items || link.items === null" :key="link.title" :to="link.to" link>
                        <v-list-item-icon>
                            <v-badge :value="!!link.badgeNum" :content="assignBadge(link)"><v-icon>{{ link.icon }}</v-icon></v-badge>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>{{ link.text }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-group v-else :key="link.title" :value="link.active">
                        <template slot="activator">
                            <v-list-item-title>
                                <span style="font-size: 15px; font-weight: 300;">{{link.text}}</span>
                            </v-list-item-title>
                        </template>
                        <template v-for="subItem in link.items" >
                            <v-list-item v-if="checkAccess(subItem.title)" v-bind:key="subItem.title" :to="subItem.to" link>
                                <v-list-item-icon>
                                    <v-icon>{{ subItem.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title v-text="subItem.text" />
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-group>
                </template>
            </template>
        </v-list>
        <v-list v-if="!$auth.loading">
            <v-list-item link v-if="$auth.isAuthenticated" @click="logout">
                <v-list-item-icon>
                    <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Log out</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link v-if="!$auth.isAuthenticated" @click="login">
                <v-list-item-icon>
                    <v-icon>mdi-login</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Log in</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import userService from '@/services/userService'
import notificationService from '@/services/notificationService'

export default {
    name: 'Drawer',
    data: () => ({
        links: [
            {
                title: 'verification',
                to: '/data-verification',
                icon: 'mdi-shield-check',
                text: 'Verification',
                items: [
                    {
                        title: 'birth-verification',
                        to: '/birth-verification',
                        icon: 'mdi-shield-check',
                        text: 'Birth Verification'
                    },
                    {
                        title: 'death-verification',
                        to: '/death-verification',
                        icon: 'mdi-shield-check',
                        text: 'Death Verification'
                    },
                    {
                        title: 'marriage-verification',
                        to: '/marriage-verification',
                        icon: 'mdi-shield-check',
                        text: 'Marriage Verification'
                    },
                    {
                        title: 'divorce-verification',
                        to: '/divorce-verification',
                        icon: 'mdi-shield-check',
                        text: 'Divorce Verification'
                    }
                ]
            },
            {
                title: 'order-certificate',
                to: '/order-certificate',
                icon: 'mdi-certificate',
                text: 'Certificate',
                items: null
            },
            {
                title: 'administration',
                to: '/',
                active: false,
                admin: true,
                text: 'Administration',
                items: [
                    {
                        title: 'user-admin',
                        to: '/user-administration',
                        icon: 'mdi-account',
                        text: 'User Admin'
                    },
                    {
                        title: 'access-requests',
                        to: '/access-requests',
                        icon: 'mdi-account-question',
                        text: 'Access Requests'
                    }
                ]
            },
            {
                title: 'mothers-worksheet',
                to: '/mothers-worksheet',
                icon: 'mdi-baby-carriage',
                text: 'Mother\'s Worksheet',
                items: null
            },
            {
                title: 'marriage-worksheet',
                to: '/marriage-worksheet',
                icon: 'mdi-ring',
                text: 'Marriage Worksheet',
                items: null
            },
            {
                title: 'inbox',
                to: '/inbox',
                icon: 'mdi-mailbox',
                text: 'Inbox',
                badgeEnum: notificationService.badgeEnum.Inbox,
                badgeNum: null,
                items: null
            },
            {
                title: 'help',
                to: '/help',
                icon: 'mdi-help',
                text: 'Help',
                items: null
            }
        ],
        logo: '/img/doh.png',
        header: '/img/header1.jpg'
    }),
    computed: {
        ...mapState('auth', ['vssUserDto']),
        userName: function () {
            return this.$auth.user.name || this.$auth.user.email
        },
        isAdmin: function () {
            return (this.vssUserDto && userService.isAdministrator())
        },
        hasRoles: function () {
            return (this.vssUserDto && userService.hasRoleList())
        }
    },
    methods: {
        assignBadge (link) {
            if (link.badgeEnum) {
                notificationService.getBadgeCountFromLinkList(this.$http, link.badgeEnum).then(res => {
                    link.badgeNum = res.data
                }).catch(error => {
                    link.badgeNum = null
                    /* eslint-disable-next-line */
                    console.error(error)
                })
            }
            return link.badgeNum
        },
        // Log the user in
        login () {
            this.$auth.loginWithRedirect()
        },
        // Log the user out
        logout () {
            this.$auth.logout({
                returnTo: window.location.origin
            })
        },
        checkAccess (menuTitle) {
            switch (menuTitle) {
            case 'administration':
                return userService.isAdministrator()
            case 'verification':
                return userService.isVerificationUser()
            case 'birth-verification':
                return userService.isBirthVerificationUser()
            case 'death-verification':
                return userService.isDeathVerificationUser()
            case 'marriage-verification':
                return userService.isMarriageVerificationUser()
            case 'divorce-verification':
                return userService.isDivorceVerificationUser()
            case 'order-certificate':
            case 'mothers-worksheet':
            case 'marriage-worksheet':
                return userService.isPublicUser()
            default:
                return this.hasRoles
            }
        }
    }
}
</script>
<style lang="scss">
    .no-hover:hover {
        background-color: transparent;
    }
    .v-list-item__title, .v-list-item_subtitle
    {
        white-space: normal !important;
    }

    .v-application--is-ltr .v-list-item__icon:first-child {
        margin-right: 24px !important;
    }
</style>
